export default {
  payWelfareText: '儲值福利',
  blackFridayDiscount: '黑五限時折扣',
  shareGift: '分享有禮',
  vipWeeklyWelfare: 'VIP每週優惠',
  exchangeCoupon: '兌換優惠券',
  firstPayOff: '首次購買最高享15%OFF',
  blackFridayEvent: '黑五活動',
  limitedTimeOff: '限時優惠10%OFF',
  claimCoupon: '立即領券',
  blackFridayTimedCoupon: '黑五限時折扣券',
  timeLeft: '活動剩餘：',
  claimTimeCoupon: '限時領取10%OFF優惠券',
  points: '剩餘積分：${point}',
  costPointTip: '消耗積分即可領取任意檔位的優惠券',
  maxPointTip: '每個帳號最多使用500積分',
  discountOff: '10%OFF',
  highestDiscount: '最高優惠 ${discount} ',
  needPoint: '需要積分 ${point}',
  changeCurrency: '更換幣種',
  claim: '領取',
  claimSucc: '領取成功',
  claimFail: '領取失敗',
  pointNotEnough: '積分不足',
  afterClaimPoint: '領取後剩餘積分：${point}',
  footTips1: '每筆訂單限使用一張優惠券',
  footTips2: '購買代金券時不支援使用該優惠券',
  footTips3: '活動最終解釋權歸遊戲營運團隊所有',
  ruleTitleText: '活動規則',
  ruleTime: '活動時間：2023-11-24 0:00 ～ 2023-11- 26 23:59 （UTC）',
  bfRuleText1:
    '1、活動期間，帳號首次登入官網儲值頁面獲得400積分，可用于兌換優惠券，最高可使用500積分；',
  bfRuleText2:
    '2、活動期間，使用黑五積分可以兌換任意額度的優惠券，優惠額度越高，需要的積分越多。兌換成功後會扣除對應的積分；',
  bfRuleText3: '3、每筆訂單限使用一張優惠券，代金券商品不支援使用黑五優惠券；',
  bfRuleText4: '4、黑五優惠券僅支持以下幣種：',
  ableCoinsType: 'USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR',
  bfRuleText5:
    '5、兌換成功後，不支持更換幣種，也不支持退還積分，請留意優惠額度和積分消耗；',
  bfRuleText6: '6、黑五優惠券有效期7天，請留意使用；',
  bfRuleText7: '7、活動最終解釋權歸遊戲營運團隊所有；',
  thanksTip: '感謝您的參與，更多支付活動請關注官方社群',
  exchangePoints: '兌換優惠券',
  exchangeCode: '輸入優惠碼',
  enterExchangeCode: '在這裡輸入優惠碼',
  exchangeText: '兌換',
  confirmGet: '確認領取',
  couponUsedWay:
    '優惠券僅支持在指定幣種的支付管道使用，請確認您希望使用的支付幣種',
  confirmText: '確認',
  exchangeSucc: '兌換成功',
  aboutCoins: '關於代金券',
  aboutCoinsText: '代金券可用於兌換本遊戲中除了代金券以外的所有禮包及增值服務',
  known: '我知道了',
  codeText: '兌換碼',
  codeInvalid: '兌換碼失效！',
  hasExchanged: '您已兌換，兌換碼只可以領取1次！',
  hideText: '收起',
  //黑五的报错码
  'bf-20001': '未登錄',
  'bf-20002': '參數錯誤，請嘗試重新進入活動',
  'bf-20003': '積分不足',
  'bf-20004': '領取失敗，請稍後再試或聯繫客服',
  'bf-20005': '已領取',
  'bf-20015': '活動未開啟，敬請期待',
  'bf-20016': '活動已結束',
  bfShareText: '限時領取10%OFF優惠券',
  rightsCenterBtn: '大會員中心',
  payBtn: '儲值',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: '購買失敗',
  productInterceptPopupTip: '抱歉該地區不支持購買該禮包<br>如有任何疑問可向客服進行諮詢',
  productInterceptPopupConfirm: '好的',
  vipHeadAwardText285 : '榮耀超凡（永久）',
  '-': '-'
};
